import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ForbiddenComponent,
  LoadingComponent,
  LogoutComponent,
  NotFoundComponent
} from './components';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';

const components = [
  LoadingComponent,
  LogoutComponent,
  NotFoundComponent,
  ForbiddenComponent,
  UnauthorizedComponent
];

@NgModule({
  imports: [CommonModule, TranslateModule, RouterModule],
  declarations: [...components],
  exports: [...components]
})
export class SharedAuthenticationUiModule {}
